import { routenames } from '@/router/routenames';
import type { NavigationEntryRaw } from '../types';

export const userNavigationRaw: NavigationEntryRaw[] = [
  {
    titleI18n: 'UserAccount_other',
    route: { name: routenames.accounts.index },
  },
  {
    titleI18n: 'Role_other',
    route: { name: routenames.roles.index },
  },
];
